const editLabel = {
    idcardFront : {
        name : {
            zh:"姓名：",
            en:"Name:"
        },
        gender : {
            zh:"性别：",
            en:"Gender:"
        },
        ethnicity : {
            zh:"民族：",
            en:"Ethnicity:"
        },
        dateOfBirth : {
            zh:"出生日期：",
            en:"Date of Birth:"
        },
        address : {
            zh:"地址：",
            en:"Residence Address:"
        },
        idnumber : {
            zh:"公民身份证号码：",
            en:"ID Number:"
        },
    },
    idcardBack : {
        first:{
            zh:"中华人民共和国",
            en:"The Resident Identity Card of the"
        },
        second:{
            zh:"居民身份证",
            en:"People’s Republic of China"
        },
        issueOrganization:{
            zh:"签发机关：",
            en:"Issued by:"
        },
        issueDate:{
            zh:"有效期限：",
            en:"Effective Period:"
        },
    }
}
export default editLabel
